import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { serverUrl } from '../constants'
import { auth } from '../firebase-config'

// Define a service using a base URL and expected endpoints
export const apiReducer = createApi({
    reducerPath: 'apiReducer',
    baseQuery: fetchBaseQuery({
        baseUrl: serverUrl,
        prepareHeaders: async (headers, { getState }) => {
            try {
                const token = await auth.currentUser.getIdToken()
                headers.set('Authorization', `Bearer ${token}`)
                headers.set('Content-Type', `application/json`)
                return headers
            } catch (e) {
                return headers
            }
        }
    }),
    tagTypes: ['User'],
    endpoints: (builder) => ({
        createUser: builder.mutation({
            query: (body) => ({
                url: `user`,
                method: 'POST',
                body
            }),
            providesTags: ['User'],
        }),
        createIncident: builder.mutation({
            query: (incidentData) => ({
                url: '/createIncident',
                method: 'POST',
                body: incidentData,
            }),
        }),
        approveIncident: builder.mutation({
            query: (incidentData) => ({
                url: '/approveIncident',
                method: 'POST',
                body: incidentData,
            }),
        }),
    })
})

export const {
    useCreateUserMutation,
    useCreateIncidentMutation,
    useApproveIncidentMutation
} = apiReducer